import { SkillsSliderField } from '@components/Molecules/SkillsSliderField';
import useSkills from '@utils/hooks/application/use-skills';
import { useStoreState } from '@app/store/hooks/index';
import { jobStoreSelector } from '@model/Job/Job.selectors';

const Skills = ({ skills, filterType }) => {
  const job = useStoreState(jobStoreSelector);
  const { requirements } = job || {};
  const result = useSkills(skills, requirements);

  return (
    <td className="c-app-showcase__cell">
      {result[filterType].map((skill, idx) => (
        <SkillsSliderField
          key={`${skill.jobRequirement.id}_${idx}`}
          label={skill.jobRequirement.description}
          value={skill.evaluation}
          className="rev-u-mb-16"
        />
      ))}
    </td>
  );
};

export default Skills;
